import React from 'react';
import { BasicText, asField } from 'informed';

export default asField(({
  fieldState, field, label, helpBlock, numbers, icon, type, ...props
}) => (
  <React.Fragment>
    <label htmlFor={field}>{label}</label>
    <div className="input-group">
      <BasicText
        className={`form-control ${fieldState.error ? 'has-error' : null}`}
        id={field}
        fieldState={fieldState}
        maxLength={numbers}
        type={type}
        {...props}
      />
      {
      icon && (
        <div className="input-group-append">
          <span className="input-group-text">
            <i className={`fas ${icon}`} />
          </span>
        </div>
       )
      }
    </div>
    {helpBlock && <small className="form-text text-muted">{helpBlock}</small>}
    {fieldState.error && <small className={fieldState.error ? 'text-danger' : null}>{fieldState.error}</small>}
  </React.Fragment>
));
